export default __webpack_public_path__ + "static/media/alfombra.3a15dcc2.png";